<!-- 兑换记录 -->
<template>
  <div class="page">
    <p class="p16">兑换记录</p>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="member-header-first">
              <el-select v-model="query.staffId" placeholder="店员姓名" filterable class="pt10">
                <el-option
                  v-for="item in staffList"
                  :key="item.id"
                  :label="item.staffName"
                  :value="item.id">
                </el-option>
              </el-select>
              <v-date @time="changeDate" class="ml10 mr10 pt10"></v-date>
              <el-input v-model="query.keyword" placeholder="姓名/手机号/身份证" clearable maxlength="18" class="select200 mr10 mt10"></el-input>
              <el-button type="primary" class="mt10" @click="doData">搜索</el-button>
            </div>
            <el-button type="primary" class="mt10" @click="exchange" v-perm="{key:'integralOrder', value: 'integralOrder:add'}">积分兑换</el-button>
          </div>
          <div class="plr16" v-perm="{key:'integralOrder', value: 'integralOrder:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="title" label="商品名称"></el-table-column>
              <el-table-column prop="itemNum" label="商品数量"></el-table-column>
              <el-table-column prop="customerName" width="auto" label="客户信息"></el-table-column>
              <el-table-column prop="itemAmount" label="原价" width="auto"></el-table-column>
              <el-table-column prop="integralAmount" label="兑换消耗积分" width="auto"></el-table-column>
              <el-table-column prop="payTime" label="兑换时间" width="auto" min-width="150px">
                <template slot-scope="scope">{{ formatDate(scope.row.payTime) }}</template>
              </el-table-column>
              <el-table-column prop="staffNames" label="技师" width="auto"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="details(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./detail";
export default {
  data() {
    return {
      url: this.$url.integralItem.lists,
      query: {
        staffId: "",
        beginTime: "",
        endTime: "",
        start: 0,
        size: 20
      },
      list: [],
      staffList: [],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: { editSet },
  computed: {},

  created() {
    this.query.beginTime = this.formatDay(new Date());
    this.query.endTime = this.query.beginTime;
    this.totalCounts();
    this.getStaff();
    
  },
  mounted () {
    if (localStorage.getItem("integralId")) {
      this.$refs["editSetForm"].$emit("set", localStorage.getItem("integralId"));
      localStorage.removeItem("integralId")
    }
  },
  methods: {
    back() {
      this.$router.push("/dataList");
    },
    details (row) {
      console.log(row);
      if (Object.keys(row).length !== 0) {
        this.$refs["editSetForm"].$emit("set", row.id);
      }
    },
    getStaff () {
      this.$api.post(this.$url.companyStaff.listAuthForData).then(res => {
        if (res) {
            this.staffList = res;
        }
      })
    },
    totalCounts () {
      this.totalCount = 0;
      this.$api.post(this.$url.integralItem.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    changeDate(value) {
      this.query.start = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      // this.getList();
    },
    exchange () {
      // 积分兑换
      this.$router.push("/dataList/integral")
    },
    selectChange() {
      this.totalCounts();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  background: #fff;
  .member-header {
    width: calc(100% - 32px);
    padding: 0 16px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .member-header-first {
      display: flex;
      // flex: 1;
      flex-wrap: wrap;
    }
  }
}

.select200 {
  width: 200px;
}
</style>

